(function () {
  function init() {
    document.querySelectorAll('a[href]').forEach(function (link) {
      var url = new URL(link.href, window.location.origin);
      if (url.origin === window.location.origin && url.pathname === '/products/rolling-gang-sheet') {
        url.searchParams.set('ml_builder', '1');
        link.href = url.toString();
      }
    });
    var page = new URL(window.location.href);
    if (page.pathname !== '/products/rolling-gang-sheet' || page.searchParams.get('ml_builder') !== '1') return;
    var tries = 0;
    var timer = window.setInterval(function () {
      tries++;
      var builder = window.gangSheetBuilder;
      if (builder && builder.ready) {
        window.clearInterval(timer);
        builder.ready.then(function (readyBuilder) {
          if (!readyBuilder || typeof readyBuilder.openDesignBuilder !== 'function') return;
          readyBuilder.openDesignBuilder();
          page.searchParams.delete('ml_builder');
          window.history.replaceState(null, '', page.toString());
        }).catch(function (error) { console.error('Unable to open the gang sheet builder', error); });
      } else if (tries >= 100) window.clearInterval(timer);
    }, 200);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();